<script>
import { SvgIcon } from '@leapsight/styleguide'
import BaseExpansionPanel from '@/components/Filter/BaseExpansionPanel.vue'
import { things } from '@/store/things';

export default {
  name: 'BaseFilter',
  components: { BaseExpansionPanel, SvgIcon },
  props: {
    tags: {
      type: Array,
      default: []
    },
    things: {
      type: Array,
      default: []
    }
  },
  data() {
    return {
      thingsChecked: {},
      selectedThings: [],
      tagsChecked: {},
      selectedTags: [],
      panelDisabled: true,
    }
  },
  computed: {
    hasEntityFilterApplied() {
      return this.selectedThings.length > 0
    },
    hasTagFilterApplied() {
      return this.selectedTags.length > 0
    },
    hasAllEntitiesSelected() {
      return this.things.length == this.selectedThings.length
    },
    hasAllTagsSelected() {
      return this.tags.length == this.selectedTags.length
    }
  },
  methods: {
    async clearFilters() {
      this.clearEntityFilters()
      this.clearTagFilters()
    },
    async clearEntityFilters() {
      this.selectedThings = []
      this.thingsChecked = {}
    },
    async clearTagFilters() {
      this.selectedTags = []
      this.tagsChecked = {}
    },
    searchThings(data, searchQuery) {
      if (searchQuery.length < 3) {
        return data
      } else {
        return this.things.filter(item =>
          item.info.label.toLowerCase().includes(searchQuery.toLowerCase())
        )
      }
    },
    searchTags(data, searchQuery) {
      if (searchQuery.length < 3) {
        return data
      } else {
        return this.tags.filter(item =>
          item.label.toLowerCase().includes(searchQuery.toLowerCase())
        )
      }
    },
    manageCheckedThings(tag, index) {
      this.test++
      const tagWasPreviouslyChecked = document.getElementById(
        `idCheckboxEtiquetas${index}`
      ).checked
      if (tagWasPreviouslyChecked) {
        for (
          let thingIndex = 0;
          thingIndex < this.things.length;
          thingIndex++
        ) {
          if (
            !this.entityHasOtherTagsChecked(
              this.things[thingIndex],
              tag.id
            )
          ) {
            for (
              let tagIndex = 0;
              tagIndex <
              this.things[thingIndex].info.tags?.length;
              tagIndex++
            ) {
              if (
                this.things[thingIndex].info.tags[tagIndex] ===
                tag.id
              ) {
                this.$set(
                  this.thingsChecked,
                  this.things[thingIndex].id,
                  false
                )
              }
            }
          }
        }
      } else {
        for (
          let thingIndex = 0;
          thingIndex < this.things.length;
          thingIndex++
        ) {
          for (
            let tagIndex = 0;
            tagIndex < this.things[thingIndex].info.tags?.length;
            tagIndex++
          ) {
            if (
              this.things[thingIndex].info.tags[tagIndex] ===
              tag?.id
            ) {
              this.$set(
                this.thingsChecked,
                this.things[thingIndex].id,
                true
              )
            }
          }
        }
      }
    },
    entityHasOtherTagsChecked(entity, tagParam) {
      let result = false
      for (let index = 0; index < entity.info?.tags?.length; index++) {
        if (
          entity.info.tags[index] !== tagParam &&
          this.tagsChecked[entity.info.tags[index]]
        ) {
          result = true
          break
        }
      }
      return result
    },
    manageCheckedTags(entity, index) {
      const entityWasPreviouslyChecked = document.getElementById(
        `idCheckboxEntidades${index}`
      ).checked
      if (entityWasPreviouslyChecked) {
        const tagsCheckedArray = Object.entries(this.tagsChecked)
        const thingsCheckedArray = Object.entries(this.thingsChecked)
        let checkedThing = {}
        const checkedThingsWithSameTag = {}
        for (let i = 0; i < entity.info?.tags?.length; i++) {
          checkedThingsWithSameTag[entity.info.tags[i]] = 0
          if (thingsCheckedArray.length > 0) {
            for (
              let j = 0;
              j < tagsCheckedArray.length && tagsCheckedArray[j][1];
              j++
            ) {
              if (entity.info.tags[i] === tagsCheckedArray[j][0]) {
                for (let k = 0; k < thingsCheckedArray.length; k++) {
                  if (thingsCheckedArray[k][1]) {
                    checkedThing = this.things.find(
                      thing => thing.id === thingsCheckedArray[k][0]
                    )
                    for (let l = 0; l < checkedThing.info?.tags?.length; l++) {
                      if (checkedThing.info.tags[l] === entity.info.tags[i]) {
                        checkedThingsWithSameTag[entity.info.tags[i]]++
                        break
                      }
                    }
                  }
                }
              }
            }
          }
        }
        for (
          let index = 0;
          index < Object.entries(checkedThingsWithSameTag).length;
          index++
        ) {
          if (Object.entries(checkedThingsWithSameTag)[index][1] === 0) {
            this.$set(
              this.tagsChecked,
              Object.entries(checkedThingsWithSameTag)[index][0],
              false
            )
          }
        }
      }
    },
    selectAllEntities() {
      this.clearFilters()
      for (let i=0;i<this.things.length;i++) {
        this.selectedThings.push(this.things[i])
        this.$set(
              this.thingsChecked,
              this.things[i].id,
              true
            )
      }
    },
    selectAllTags() {
      this.clearFilters()
      for (let i=0;i<this.tags.length;i++) {
        this.selectedTags.push(this.tags[i])
        this.$set(
              this.tagsChecked,
              this.tags[i].id,
              true
            )
        this.manageCheckedThings(this.tags[i], i)
      }
    }
  },
  watch: {
    selectedThings: {
      handler(newValue) {
        this.$emit('updateThingsApplied', newValue)
      }
    },
    thingsChecked: {
      handler(value) {
        for (const item of Object.entries(value)) {
          const thingID = item[0]
          const checked = item[1]
          const thing = this.things.find(
            thing => thing.id === thingID
          )
          if (thing !== -1) {
            if (!checked) {
              const index = this.selectedThings.findIndex(
                st => st.id === thingID
              )
              if (index !== -1) {
                this.selectedThings.splice(index, 1)
              }
            } else if (this.selectedThings.every(st => st.id !== thingID)) {
              this.selectedThings.push(thing)
            }
          }
        }
      },
      deep: true
    },
    tagsChecked: {
      handler(value) {
        for (const item of Object.entries(value)) {
          const tagID = item[0]
          const checked = item[1]
          const tag = this.tags.find(tag => tag.id === tagID)
          if (tag !== -1) {
            if (!checked) {
              const index = this.selectedTags.findIndex(st => st.id === tagID)
              if (index !== -1) {
                this.selectedTags.splice(index, 1)
              }
            } else if (this.selectedTags.every(st => st.id !== tagID)) {
              this.selectedTags.push(tag)
            }
          }
        }
      },
      deep: true
    },
    hasEntityFilterApplied(newValue) {
      this.$emit('updateIsFilterApplied', newValue)
    },
    things(newValue) {
      this.clearFilters()
      if (newValue.length > 0) this.panelDisabled = false;
    }
  },
  async created() {

  }
}
</script>

<template>
  <div>
    <div class="pulser" v-if="$store.state.filterMustBeApplied"></div>
    
      <v-container style="width: 400px" class="pa-7">
        
          <v-row>
            <v-col class="px-0 pt-0">
              <v-expansion-panels class="pt-3" :disabled="panelDisabled">
                <BaseExpansionPanel
                  :data="things"
                  :searchFn="searchThings"
                  label="Entidades"
                  required
                >
                  <template v-slot:chipGroup>
                    <template v-for="(item, index) of selectedThings">
                      <v-chip small v-if="index < 3" :key="item">
                        <span>{{ item.info.label }}</span>
                      </v-chip>
                      <span
                        v-else-if="index === 3"
                        class="grey--text caption pr-5 align-content-center"
                        :key="item"
                      >
                        (+{{ selectedThings.length - 3 }})
                      </span>
                    </template>
                  </template>
                  <template v-slot:eachRow="{ data }">
                    <tr v-for="(item, index) in data" :key="item.id">
                      <td>
                        <v-checkbox
                          :id="`idCheckboxEntidades${index}`"
                          v-model="thingsChecked[item.id]"
                          @click="manageCheckedTags(item, index)"
                        ></v-checkbox>
                      </td>
                      <td>
                        {{ item.info.label }}
                      </td>
                    </tr>
                  </template>
                </BaseExpansionPanel>
              </v-expansion-panels>
              <h4
                v-if="this.selectedThings.length >= 1000"
                class="red--text text-body-2 font-weight-bold"
              >
                {{
                  $t('live_tracking.map.filters.alert_max_amount_of_entities')
                }}
              </h4>
            </v-col>
          </v-row>
          <v-row justify="end">
            <v-col class="pa-0 mx-2" cols="auto"
              ><v-btn
                id="idBtnQuitarFiltrosEntidades"
                color="tertiary white--text"
                rounded
                depressed
                @click="selectAllEntities"
                :disabled="hasAllEntitiesSelected"
                small
                >Seleccionar todos</v-btn
              >
            </v-col>
            <v-col class="pa-0 mx-2" cols="auto"
              ><v-btn
                id="idBtnQuitarFiltrosEntidades"
                color="tertiary white--text"
                rounded
                depressed
                @click="clearFilters"
                :disabled="!hasEntityFilterApplied"
                small
                >Quitar todos</v-btn
              >
            </v-col>
          </v-row>
          <br />
          <br />
          <v-row>
            <v-col class="px-0 pt-0">
              <v-expansion-panels class="pt-3" :disabled="panelDisabled">    
                <BaseExpansionPanel
                  :data="tags"
                  :searchFn="searchTags"
                  label="Etiquetas"
                >
                  <template v-slot:chipGroup>
                    <template v-for="(item, index) of selectedTags">
                      <v-chip small v-if="index < 3" :key="item">
                        <span>{{ item.label }}</span>
                      </v-chip>
                      <span
                        v-else-if="index === 3"
                        class="grey--text caption pr-5 align-content-center"
                        :key="item"
                      >
                        (+{{ selectedTags.length - 3 }})
                      </span>
                    </template>
                  </template>
                  <template v-slot:eachRow="{ data }">
                    <tr v-for="(item, index) in data" :key="item.id">
                      <td>
                        <v-checkbox
                          :id="`idCheckboxEtiquetas${index}`"
                          v-model="tagsChecked[item.id]"
                          @click="manageCheckedThings(item, index)"
                        ></v-checkbox>
                      </td>
                      <td>{{ item.label }}</td>
                    </tr>
                  </template>
                </BaseExpansionPanel>
              </v-expansion-panels>
              <h4
                v-if="this.selectedThings.length >= 1000"
                class="red--text text-body-2 font-weight-bold"
              >
                {{
                  $t('live_tracking.map.filters.alert_max_amount_of_entities')
                }}
              </h4>
            </v-col>
          </v-row>
          <v-row justify="end">
            <v-col class="pa-0 mx-2" cols="auto"
              ><v-btn
                id="idBtnQuitarFiltrosEntidades"
                color="tertiary white--text"
                rounded
                depressed
                @click="selectAllTags"
                :disabled="hasAllTagsSelected"
                small
                >Seleccionar todos</v-btn
              >
            </v-col>
            <v-col class="pa-0 mx-2" cols="auto"
              ><v-btn
                id="idBtnQuitarFiltrosEntidades"
                color="tertiary white--text"
                rounded
                depressed
                @click="clearFilters"
                :disabled="!hasTagFilterApplied"
                small
                >Quitar todos</v-btn
              >
            </v-col>
          </v-row>
      </v-container>
   
  </div>
</template>

<style scoped lang="scss">
.active__filter_things {
  border: 2px solid var(--dark-hot-pink) !important;
}

.pulser {
  width: 40px;
  height: 40px;
  background: rgba(255, 107, 14, 0.2);
  border-radius: 50%;
  position: absolute;
  top: 81px;
  right: 19px;
  z-index: 0;
}

.pulser::after {
  content: '';
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: rgba(255, 107, 14, 0.3);
  border-radius: 50%;
  z-index: -1;

  animation: pulse;
  animation-duration: 2s;
  animation-timing-function: ease-in-out;
  animation-iteration-count: 5;
}

@keyframes pulse {
  0% {
    opacity: 0;
  }

  50% {
    scale: 2;
    opacity: 0.4;
  }

  100% {
    opacity: 0.8;
  }
}
</style>
